import * as React from "react";
import { Outlet } from "react-router-dom";
import AdminHeader from "../components/Admin/AdminLayout/AdminHeader";
import AdminSidebar from "../components/Admin/AdminLayout/AdminSidebar";
import Drawer from "@mui/material/Drawer";
import Grid from "@mui/material/Grid2";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";

const drawerWidth = 240;

const AdminPage = () => {
  const navigate = useNavigate();

  React.useEffect(() => {
    const userId = localStorage.getItem("userId");
    if (!userId) {
      navigate(`/admin/login`);
      return;
    }

    axios
      .get(`/api/v1/users/${userId}`)
      .catch(() => {
        toast("Hết thời gian làm việc, vui lòng đăng nhập lại", {
          type: "error",
          autoClose: 2000,
        });
        localStorage.removeItem("accessToken");
        localStorage.removeItem("userId");
        localStorage.removeItem("permissions");
        navigate("/admin/login");
      });
  }, [navigate]);

  return (
    <Grid
      container
      sx={{
        width: "100vw",
        height: "100vh",
        overflow: "hidden",
      }}
    >
      <Grid
        sx={{
          width: `${drawerWidth}px`,
          height: "100vh",
        }}
      >
        <Drawer
          open={true}
          variant="permanent"
          sx={{
            display: { xs: "none", sm: "block" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
              height: "100vh",
            },
          }}
        >
          <AdminSidebar />
        </Drawer>
      </Grid>
      <Grid
        sx={{
          flex: 1,
          height: "100vh",
          overflowY: "auto",
        }}
      >
        <AdminHeader />
        <Outlet />
      </Grid>
    </Grid>
  );
};

export default AdminPage;
